export const table_config = {
  actions: {
    single: (tenant) => [
      [
        { label: 'View', value: 'view', hidden: !tenant.is_active },
        { label: 'Edit', value: 'edit', hidden: !tenant.is_active },
        { label: 'Top Up', value: 'top up', hidden: !tenant.is_active },
        { label: 'Assign Subscription', value: 'assign_subscription', hidden: !tenant.is_active },
        { label: 'Configure Retention', value: 'retention_config', hidden: !tenant.is_active },
        { label: 'Generate Invoice', value: 'generate_invoice', hidden: !tenant.is_active },
        { label: 'Add Issue', value: 'add_issue', hidden: !tenant.is_active },
        { label: 'Update Contact', value: 'update_contact', hidden: !tenant.is_active },
        { label: 'Mark as Internal', value: 'mark_internal', hidden: tenant.metadata?.is_internal }
      ],
      [{ label: 'Delete', value: 'delete' }]
    ]
  },
  css: {},
  fields: [
    {
      title: 'Name',
      key: 'name',
      isTitle: true,
      searchable: true
    },
    {
      title: 'Email',
      key: 'email',
      isTagline: true,
      searchable: true
    },
    {
      title: 'Status',
      key: 'status',
      isTagline: true,
      formatter: (value) => value || 'new'
    },
    {
      title: 'Date joined',
      key: 'created_on',
      formatter: (value) => (value ? new Date(value).toDateString() : ''),
      isMetadata: true
    }
  ],
  items: [],
  search_key: 'name',
  search_text: 'Search tenants'
};
